// ════════════════════════════════════════════
// ACCE SCHOOL — BRAND PALETTE
// Sourced from logo: Deep Navy, Orange, Light Gray
// ════════════════════════════════════════════

export const ACCE_BRAND = {
  // ── Core brand colors (from logo) ──
  navy:        '#2A3A54',   // Main logo / text
  navyDark:    '#1E2A3E',   // Deeper navy for gradients/shadows
  navyLight:   '#3D5273',   // Lighter navy for hover states
  orange:      '#F3811E',   // Swoosh / accent
  orangeDark:  '#D96A0A',   // Darker orange for gradients
  orangeLight: '#FFA04D',   // Lighter orange for highlights
  gray:        '#D0D1D3',   // Outer petals / secondary
  grayDark:    '#A8AAB0',   // Darker gray
  grayLight:   '#ECEDEF',   // Very light gray

  // ── Derived / semantic ──
  white:       '#FFFFFF',
  offWhite:    '#FAFBFC',
  darkText:    '#1A2233',
  bodyText:    '#4A5568',
  mutedText:   '#8896A6',

  // ── Gradients ──
  navyGradient:    'linear-gradient(135deg, #1E2A3E 0%, #2A3A54 50%, #3D5273 100%)',
  orangeGradient:  'linear-gradient(135deg, #D96A0A 0%, #F3811E 50%, #FFA04D 100%)',
  brandGradient:   'linear-gradient(135deg, #2A3A54 0%, #F3811E 100%)',
  accentBar:       'linear-gradient(90deg, #2A3A54, #F3811E, #FFA04D, #F3811E, #2A3A54)',
  softBackdrop:    'linear-gradient(135deg, #FAFBFC 0%, #F0F2F5 100%)',
};

// ── MUI Theme Augmentation ──
export const acceTheme = {
  palette: {
    primary:   { main: ACCE_BRAND.navy,   light: ACCE_BRAND.navyLight,   dark: ACCE_BRAND.navyDark },
    secondary: { main: ACCE_BRAND.orange, light: ACCE_BRAND.orangeLight, dark: ACCE_BRAND.orangeDark },
    background:{ default: ACCE_BRAND.offWhite, paper: ACCE_BRAND.white },
    text:      { primary: ACCE_BRAND.darkText, secondary: ACCE_BRAND.bodyText },
  },
  typography: {
    fontFamily: '"Inter", "Poppins", "Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-0.5px' },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 14 },
};

// ── Reusable glossy button style ──
export const glossyButton = (base, dark, light) => ({
  background: `linear-gradient(135deg, ${dark} 0%, ${base} 50%, ${light} 100%)`,
  boxShadow: `0 8px 28px ${base}55, inset 0 1px 0 rgba(255,255,255,0.3), inset 0 -2px 6px rgba(0,0,0,0.15)`,
  position: 'relative',
  overflow: 'hidden',
});